/**
 * @desc 新增
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.LogisticsCycleInfoRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/logisticsCycleInfo/create`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
